import {
  TRACK_RELEASE_TYPE_OPTIONS,
  TRACK_ROLE_OPTIONS,
  TRACKS_FILTER_PARAMS,
} from '~/modules/artist-roster/pages/artist-details/utils/constants';
import type {
  TrackReleaseTypeOptions,
  TrackRoleOptions,
  TracksFilters,
} from '~/modules/artist-roster/pages/artist-details/utils/types';

function getValue<T extends readonly string[]>(
  urlParams: URLSearchParams,
  name: string,
  validValues: T,
): T[number] | undefined {
  const value = urlParams.get(name);

  if (value && validValues.includes(value)) {
    return value as T[number];
  }
}

export function parseFiltersFromUrlParams(
  urlParams: URLSearchParams,
): TracksFilters {
  const searchText =
    urlParams.get(TRACKS_FILTER_PARAMS.searchText) || undefined;

  const releaseType = getValue<TrackReleaseTypeOptions>(
    urlParams,
    TRACKS_FILTER_PARAMS.releaseType,
    TRACK_RELEASE_TYPE_OPTIONS,
  );

  const role = getValue<TrackRoleOptions>(
    urlParams,
    TRACKS_FILTER_PARAMS.role,
    TRACK_ROLE_OPTIONS,
  );

  return {
    searchText,
    releaseType,
    role,
  };
}

/**
 * Function takes a set of TracksFilters and returns URLSearchParams
 */
export function formatFiltersToUrlParams(
  filters: Partial<TracksFilters>,
): URLSearchParams {
  const newUrlParams = new URLSearchParams();

  if (filters.searchText) {
    newUrlParams.set(TRACKS_FILTER_PARAMS.searchText, filters.searchText);
  }

  if (
    filters.releaseType &&
    TRACK_RELEASE_TYPE_OPTIONS.includes(filters.releaseType)
  ) {
    newUrlParams.set(TRACKS_FILTER_PARAMS.releaseType, filters.releaseType);
  }

  if (filters.role && TRACK_ROLE_OPTIONS.includes(filters.role)) {
    newUrlParams.set(TRACKS_FILTER_PARAMS.role, filters.role);
  }

  return newUrlParams;
}
